import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Sperrt die Navigation in der nativen App (Back-Geste, Back-Button, Swipe-Back).
// Verhindert auch Web-seitige Navigation via turbo:before-visit.
//
// Verwendung:
//   <div data-controller="native--navigation-lock"
//        data-native--navigation-lock-active-value="true"
//        data-native--navigation-lock-message-value="Firmware-Update läuft...">
//   </div>
//
// Stimulus API:
//   - data-native--navigation-lock-active-value="true/false" zum Aktivieren/Deaktivieren
//   - data-action="native--navigation-lock#lock" / "native--navigation-lock#unlock"

// Connects to data-controller="native--navigation-lock"
export default class extends BridgeComponent {
  static component = "navigation-lock"
  static values = {
    message: { type: String, default: null },
    active: { type: Boolean, default: false },
  }

  connect() {
    super.connect()
    this.turboBeforeVisitHandler = this.#preventTurboNavigation.bind(this)

    if (this.activeValue) {
      this.lock()
    }
  }

  disconnect() {
    this.unlock()
    this.#removeWebLock()

    super.disconnect()
  }

  activeValueChanged() {
    if (this.activeValue) {
      this.lock()
    } else {
      this.unlock()
    }
  }

  lock() {
    this.activeValue = true
    this.send("lock", { message: this.messageValue })
    this.#addWebLock()
  }

  unlock() {
    this.activeValue = false
    this.send("unlock")
    this.#removeWebLock()
  }

  // Web-seitige Navigation verhindern (Turbo-Links, Browser-Refresh)
  #addWebLock() {
    document.addEventListener("turbo:before-visit", this.turboBeforeVisitHandler)
  }

  #removeWebLock() {
    document.removeEventListener("turbo:before-visit", this.turboBeforeVisitHandler)
  }

  #preventTurboNavigation(event) {
    if (this.activeValue) {
      event.preventDefault()
    }
  }
}
